var AnswersCollection = Chaplin.Collection.extend({
  model: EF.Models.Assessments.Answer
});

_.extend(EF.Collections.Assessments, {
  AnswersCollection: AnswersCollection
});
